import { render, staticRenderFns } from "./Rent.vue?vue&type=template&id=215796f2&"
import script from "./Rent.vue?vue&type=script&lang=ts&"
export * from "./Rent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports